// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"215ec98a","administration":"9ca3bbc5"}[chunkId] + ".chunk.js";
};